msgid ""
msgstr ""
"POT-Creation-Date: 2026-09-11 17:28+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=utf-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: zh-CN\n"
"Project-Id-Version: \n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: \n"
"Last-Translator: \n"
"Language-Team: \n"
"Plural-Forms: \n"

#. placeholder {0}: ordered.length
#: src/components/ExecutionUsageChip.tsx
msgid "{0, plural, one {# execution total} other {# executions total}}"
msgstr "{0, plural, one {共 # 次执行} other {共 # 次执行}}"

#. placeholder {0}: day.messages
#: src/components/PersonalOverview.tsx
msgid "{0, plural, one {# message} other {# messages}}"
msgstr "{0, plural, one {# 条消息} other {# 条消息}}"

#. placeholder {0}: day.tasks_created
#: src/components/PersonalOverview.tsx
msgid "{0, plural, one {# task created} other {# tasks created}}"
msgstr "{0, plural, one {创建了 # 个任务} other {创建了 # 个任务}}"

#. placeholder {0}: person.task_count
#: src/components/PersonalOverview.tsx
msgid "{0, plural, one {# task together} other {# tasks together}}"
msgstr "{0, plural, one {共同参与 # 个任务} other {共同参与 # 个任务}}"

#. placeholder {0}: members.length
#: src/components/InsightsPanel.tsx
msgid "{0, plural, one {active collaborator} other {active collaborators}}"
msgstr "{0, plural, one {位活跃协作者} other {位活跃协作者}}"

#. placeholder {0}: active.length
#: src/components/InsightsPanel.tsx
msgid "{0, plural, one {work item in motion} other {work items in motion}}"
msgstr "{0, plural, one {项进行中的工作} other {项进行中的工作}}"

#. placeholder {0}: formatDate(i18n, new Date(`${day.date}T00:00:00Z`), { dateStyle: 'medium', timeZone: 'UTC' })
#: src/components/PersonalOverview.tsx
msgid "{0} (UTC)"
msgstr "{0}（UTC）"

#. placeholder {0}: task.title
#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "{0} has no task thread"
msgstr "{0} 没有关联的任务讨论串"

#. placeholder {0}: formatNumber(i18n, done)
#. placeholder {1}: formatNumber(i18n, plan.length)
#: src/components/ActivityPanel.tsx
msgid "{0} of {1} done"
msgstr "已完成 {0} / {1}"

#. placeholder {0}: formatNumber(i18n, left)
#: src/components/ActivityPanel.tsx
msgid "{0} to go"
msgstr "还剩 {0} 项"

#. placeholder {0}: formatTokens(i18n, total)
#: src/components/ExecutionUsageChip.tsx
msgid "{0} tok"
msgstr "{0} token"

#. placeholder {0}: formatTokens(i18n, total)
#: src/components/InsightsPanel.tsx
msgid "{0} tokens"
msgstr "{0} token"

#. placeholder {0}: formatNumber(i18n, minutes)
#: src/components/ActivityPanel.tsx
msgid "{0}m"
msgstr "{0}分钟"

#: src/components/ActivityBar.tsx
msgid "{active, plural, one {# active} other {# active}} · {total, plural, one {# background run} other {# background runs}}"
msgstr "{active, plural, one {# 个活跃} other {# 个活跃}} · {total, plural, one {# 个后台运行} other {# 个后台运行}}"

#: src/lib/channel-activity.ts
msgid "{count, plural, one {# agent waiting for you} other {# agents waiting for you}}"
msgstr "{count, plural, one {# 个 Agent 正在等待你} other {# 个 Agent 正在等待你}}"

#: src/lib/channel-activity.ts
msgid "{count, plural, one {# agent working} other {# agents working}}"
msgstr "{count, plural, one {# 个 Agent 正在工作} other {# 个 Agent 正在工作}}"

#: src/lib/channel-activity.ts
msgid "{count, plural, one {# person typing} other {# people typing}}"
msgstr "{count, plural, one {# 人正在输入} other {# 人正在输入}}"

#: src/components/InsightsPanel.tsx
msgid "{done, plural, one {completed task contribution} other {completed task contributions}}"
msgstr "{done, plural, one {次已完成任务贡献} other {次已完成任务贡献}}"

#: src/lib/channel-activity.ts
msgid "{first} and {second} are typing"
msgstr "{first} 和 {second} 正在输入"

#: src/lib/channel-activity.ts
msgid "{first} and {second} are waiting for you"
msgstr "{first} 和 {second} 正在等待你"

#: src/lib/channel-activity.ts
msgid "{first} and {second} are working"
msgstr "{first} 和 {second} 正在工作"

#: src/lib/channel-activity.ts
msgid "{first} is typing"
msgstr "{first} 正在输入"

#: src/lib/channel-activity.ts
msgid "{first} is waiting for you"
msgstr "{first} 正在等待你"

#: src/lib/channel-activity.ts
msgid "{first} is working"
msgstr "{first} 正在工作"

#: src/components/StopTurnButton.tsx
msgid "{label}, {displayName}"
msgstr "{label}，{displayName}"

#. placeholder {0}: formatTokens(i18n, value)
#: src/components/ExecutionUsageChip.tsx
msgid "{name}: {0}"
msgstr "{name}：{0}"

#: src/components/ExecutionUsageChip.tsx
msgid "{scopeTitle}. {label}."
msgstr "{scopeTitle}。{label}。"

#: src/components/ExecutionUsageChip.tsx
msgid "{scopeTitle}. View token usage."
msgstr "{scopeTitle}。查看 token 用量。"

#: src/components/ActivityBar.tsx
msgid "{total, plural, one {# background run} other {# background runs}}"
msgstr "{total, plural, one {# 个后台运行} other {# 个后台运行}}"

#: src/components/PersonalOverview.tsx
msgid "{total, plural, one {# message in the last year} other {# messages in the last year}}"
msgstr "{total, plural, one {过去一年共 # 条消息} other {过去一年共 # 条消息}}"

#: src/components/InsightsPanel.tsx
msgid "{totalMessages, plural, one {# message} other {# messages}} · {totalTasks, plural, one {# task contribution} other {# task contributions}}"
msgstr "{totalMessages, plural, one {# 条消息} other {# 条消息}} · {totalTasks, plural, one {# 次任务贡献} other {# 次任务贡献}}"

#: src/components/ExecutionUsageChip.tsx
msgid "Abandoned"
msgstr "已中断"

#: src/components/ActivityPanel.tsx
msgid "Active now"
msgstr "当前活动"

#: src/components/TasksPanel.tsx
msgid "Additional check instructions (e.g. check deploy health, summarize for customer)"
msgstr "补充检查说明（例如检查部署健康状况、为客户总结进展）"

#: src/components/TasksPanel.tsx
msgid "Advanced: Custom Prompt (optional)"
msgstr "高级：自定义提示词（可选）"

#: src/components/PersonalOverview.tsx
msgid "Agent"
msgstr "Agent"

#: src/components/TaskPropertiesEditor.tsx
msgid "Agent Session"
msgstr "Agent 会话"

#: src/components/PersonalOverview.tsx
msgid "Agents do work in your spaces."
msgstr "Agent 会在你的空间中执行工作。"

#: src/components/PersonalTasksPage.tsx
#: src/components/TasksPanel.tsx
msgid "All"
msgstr "全部"

#: src/components/ExecutionUsageChip.tsx
msgid "All executions"
msgstr "全部执行"

#: src/components/ServerTasksPage.tsx
msgid "All tasks"
msgstr "全部任务"

#: src/components/StopTurnButton.tsx
msgid "Already asked to stop"
msgstr "已请求停止"

#: src/components/ActivityPanel.tsx
msgid "Already stopping"
msgstr "正在停止中"

#. placeholder {0}: task.seq
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Are you sure you want to delete task #{0}?"
msgstr "确定要删除任务 #{0} 吗？"

#: src/components/PersonalOverview.tsx
msgid "Assign your first Task"
msgstr "分配你的第一个任务"

#: src/components/PersonalTasksPage.tsx
msgid "Assigned to you"
msgstr "分配给你"

#: src/components/ServerTasksPage.tsx
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Assignee"
msgstr "负责人"

#: src/components/InsightsPanel.tsx
msgid "Authorized Project message and Task creation activity over the last year (UTC)"
msgstr "过去一年你有权查看的项目消息和任务创建活动（UTC）"

#: src/components/ActivityPanel.tsx
msgid "Background completed"
msgstr "后台工作已完成"

#: src/components/ActivityPanel.tsx
msgid "Background failed"
msgstr "后台工作失败"

#: src/components/ActivityPanel.tsx
msgid "background job"
msgstr "后台作业"

#: src/components/ActivityPanel.tsx
msgid "Background work"
msgstr "后台工作"

#: src/components/TasksPanel.tsx
msgid "Board view"
msgstr "看板视图"

#: src/components/ExecutionUsageChip.tsx
msgid "Cache"
msgstr "缓存"

#. placeholder {0}: formatTokens(i18n, execution.cache_read_tokens + execution.cache_write_tokens)
#: src/components/ExecutionUsageChip.tsx
msgid "Cache: {0}"
msgstr "缓存：{0}"

#: src/components/PersonalOverview.tsx
#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Cancel"
msgstr "取消"

#: src/components/ActivityPanel.tsx
#: src/lib/taskStatus.tsx
msgid "Cancelled"
msgstr "已取消"

#: src/components/ServerTasksPage.tsx
#: src/components/TasksTableView.tsx
msgid "Channel"
msgstr "频道"

#: src/components/ExecutionUsageChip.tsx
msgid "Channel rollup"
msgstr "频道汇总"

#: src/components/ServerTasksPage.tsx
msgid "Channel unavailable"
msgstr "频道不可用"

#: src/components/ActivityPanel.tsx
msgid "Close"
msgstr "关闭"

#: src/components/InsightsPanel.tsx
msgid "Collaboration"
msgstr "协作"

#: src/components/TasksBoardView.tsx
msgid "Collapse {label} column"
msgstr "收起“{label}”列"

#: src/components/PersonalOverview.tsx
msgid "Color represents messages from you and your Agents in related Task threads; Task count is shown separately. Project Insights remains the whole space’s activity."
msgstr "颜色表示你和你的 Agent 在相关任务讨论串中的消息量；任务数单独显示。项目洞察展示整个空间的活动。"

#: src/components/InsightsPanel.tsx
msgid "Color represents messages. Tooltip counts show messages and canonical Tasks created on each UTC day across Channels you are authorized to view."
msgstr "颜色表示消息量。提示中显示你有权查看的频道在每个 UTC 日期的消息数和新建任务数。"

#: src/components/ActivityPanel.tsx
#: src/components/PersonalTasksPage.tsx
msgid "Completed"
msgstr "已完成"

#: src/components/PersonalOverview.tsx
msgid "Connect a computer when your Agents need one."
msgstr "当你的 Agent 需要电脑时，可在此连接。"

#: src/components/PersonalOverview.tsx
msgid "Connected recently"
msgstr "最近连接过"

#: src/components/PersonalOverview.tsx
msgid "Continue"
msgstr "继续"

#: src/components/PersonalOverview.tsx
msgid "Continue: {taskTitle}"
msgstr "继续：{taskTitle}"

#: src/components/TaskPropertiesEditor.tsx
msgid "Copied"
msgstr "已复制"

#. placeholder {0}: propertyLabel(definition, i18n)
#: src/components/TaskPropertiesEditor.tsx
msgid "Copied {0}"
msgstr "已复制{0}"

#. placeholder {0}: propertyLabel(definition, i18n)
#: src/components/TaskPropertiesEditor.tsx
msgid "Copy {0}"
msgstr "复制{0}"

#: src/components/TaskPropertiesEditor.tsx
msgid "Copy failed"
msgstr "复制失败"

#: src/components/TasksPanel.tsx
msgid "Could not create the task. Your inputs are still here; retry when ready."
msgstr "无法创建任务。已保留填写的内容，请稍后重试。"

#: src/components/ServerTasksPage.tsx
msgid "Could not create the task. Your inputs are still here."
msgstr "无法创建任务。已保留填写的内容。"

#: src/components/ServerTasksPage.tsx
msgid "Could not load channel members. Close and reopen this form to retry."
msgstr "无法加载频道成员。请关闭并重新打开此表单以重试。"

#: src/components/ServerTasksPage.tsx
msgid "Could not load Project tasks."
msgstr "无法加载项目任务。"

#: src/components/TasksPanel.tsx
msgid "Could not load repository mappings from the selected computer. Check Remote Helper, then retry."
msgstr "无法从所选电脑加载仓库映射。请检查 Remote Helper 后重试。"

#: src/components/PersonalOverview.tsx
msgid "Could not load your overview."
msgstr "无法加载你的概览。"

#: src/components/TasksPanel.tsx
msgid "Could not save the task. Your inputs are still here; retry when ready."
msgstr "无法保存任务。已保留填写的内容，请稍后重试。"

#: src/components/ActivityPanel.tsx
#: src/components/StopTurnButton.tsx
msgid "Could not stop"
msgstr "无法停止"

#: src/components/ServerTasksPage.tsx
#: src/components/TasksPanel.tsx
msgid "Create"
msgstr "创建"

#: src/components/PersonalOverview.tsx
msgid "Create Agent"
msgstr "创建 Agent"

#: src/components/PersonalOverview.tsx
msgid "Create an Agent to start collaborating."
msgstr "创建 Agent 以开始协作。"

#: src/components/PersonalOverview.tsx
msgid "Create your first Agent"
msgstr "创建你的第一个 Agent"

#: src/components/PersonalTasksPage.tsx
msgid "Created by you"
msgstr "由你创建"

#: src/components/TasksPanel.tsx
msgid "Creating..."
msgstr "正在创建..."

#: src/components/ServerTasksPage.tsx
msgid "Creating…"
msgstr "正在创建…"

#: src/components/TasksPanel.tsx
msgid "Creator"
msgstr "创建者"

#: src/components/InsightsPanel.tsx
msgid "Daily token consumption"
msgstr "每日 token 用量"

#: src/components/TasksPanel.tsx
msgid "Default execution"
msgstr "默认执行方式"

#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Delete"
msgstr "删除"

#. placeholder {0}: task.title
#: src/components/TaskRowActions.tsx
msgid "Delete {0}"
msgstr "删除{0}"

#: src/components/TasksTableView.tsx
msgid "Delete task"
msgstr "删除任务"

#: src/components/TasksPanel.tsx
msgid "Delete Task"
msgstr "删除任务"

#. placeholder {0}: task.seq
#: src/components/TaskRowActions.tsx
msgid "Delete task #{0}?"
msgstr "删除任务 #{0}？"

#: src/components/TasksTableView.tsx
msgid "Delete task?"
msgstr "删除任务？"

#: src/components/ServerTasksPage.tsx
#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
msgid "Description"
msgstr "描述"

#: src/components/TaskHeartbeatControl.tsx
msgid "Disable heartbeat"
msgstr "停用心跳"

#: src/components/ActivityPanel.tsx
#: src/lib/taskStatus.tsx
msgid "Done"
msgstr "完成"

#: src/components/TasksPanel.tsx
msgid "e.g. Check deploy health and summarize the current status"
msgstr "例如：检查部署健康状况并总结当前状态"

#. placeholder {0}: task.title
#: src/components/TaskRowActions.tsx
msgid "Edit {0}"
msgstr "编辑{0}"

#: src/components/TaskRowActions.tsx
#: src/components/TasksBoardView.tsx
#: src/components/TasksTableView.tsx
msgid "Edit task"
msgstr "编辑任务"

#: src/components/TasksPanel.tsx
msgid "Edit Task"
msgstr "编辑任务"

#: src/components/TaskHeartbeatControl.tsx
msgid "Enable heartbeat"
msgstr "启用心跳"

#: src/lib/taskHeartbeat.ts
msgid "Every 1 hour"
msgstr "每 1 小时"

#: src/lib/taskHeartbeat.ts
msgid "Every 10 minutes"
msgstr "每 10 分钟"

#: src/lib/taskHeartbeat.ts
msgid "Every 15 minutes"
msgstr "每 15 分钟"

#: src/lib/taskHeartbeat.ts
msgid "Every 2 hours"
msgstr "每 2 小时"

#: src/lib/taskHeartbeat.ts
msgid "Every 30 minutes"
msgstr "每 30 分钟"

#: src/lib/taskHeartbeat.ts
msgid "Every 5 minutes"
msgstr "每 5 分钟"

#. placeholder {0}: formatNumber(i18n, index + 1)
#: src/components/ExecutionUsageChip.tsx
msgid "Execution {0}"
msgstr "第 {0} 次执行"

#: src/components/ActivityPanel.tsx
msgid "Execution detail"
msgstr "执行详情"

#: src/components/TaskPropertiesEditor.tsx
msgid "Execution Local Directory"
msgstr "本地执行目录"

#: src/components/TaskPropertiesEditor.tsx
msgid "Execution Remote Node"
msgstr "执行电脑"

#: src/components/TaskPropertiesEditor.tsx
msgid "Execution Repository"
msgstr "执行仓库"

#: src/components/ExecutionUsageChip.tsx
msgid "Execution token trend, oldest to newest"
msgstr "执行 token 用量趋势，从最早到最新"

#: src/components/TasksPanel.tsx
msgid "Execution Workspace"
msgstr "执行工作区"

#: src/components/TaskPropertiesEditor.tsx
msgid "Execution Workspace Source"
msgstr "执行工作区来源"

#: src/components/ExecutionUsageChip.tsx
msgid "Executions"
msgstr "执行次数"

#: src/components/TasksBoardView.tsx
msgid "Expand {label} column"
msgstr "展开“{label}”列"

#: src/components/ActivityPanel.tsx
#: src/components/ExecutionUsageChip.tsx
msgid "Failed"
msgstr "失败"

#: src/components/TaskRowActions.tsx
#: src/components/TasksTableView.tsx
msgid "Failed to delete task"
msgstr "删除任务失败"

#: src/components/InsightsPanel.tsx
msgid "Failed to load Project insights."
msgstr "加载项目洞察失败。"

#: src/components/TaskHeartbeatControl.tsx
msgid "Failed to update heartbeat"
msgstr "更新心跳失败"

#: src/components/TaskRowActions.tsx
msgid "Failed to update task"
msgstr "更新任务失败"

#: src/components/ExecutionUsageChip.tsx
msgid "Finished"
msgstr "已结束"

#: src/components/PersonalOverview.tsx
msgid "Fri"
msgstr "周五"

#: src/components/TasksPanel.tsx
msgid "GitHub Repository"
msgstr "GitHub 仓库"

#: src/components/TasksPanel.tsx
msgid "GitHub Repository on selected computer"
msgstr "所选电脑上的 GitHub 仓库"

#: src/components/PersonalOverview.tsx
msgid "Give one of your Agents work in a channel."
msgstr "在频道中为你的 Agent 分配工作。"

#: src/components/TasksPanel.tsx
msgid "Heartbeat"
msgstr "心跳"

#: src/components/ActivityPanel.tsx
msgid "Hide"
msgstr "隐藏"

#: src/components/ExecutionUsageChip.tsx
msgid "Hide execution details"
msgstr "隐藏执行详情"

#: src/components/PersonalOverview.tsx
msgid "Hover a day for details"
msgstr "将鼠标移到日期上查看详情"

#: src/components/TasksTableView.tsx
msgid "ID"
msgstr "ID"

#: src/components/PersonalOverview.tsx
msgid "Idle"
msgstr "空闲"

#: src/components/ExecutionUsageChip.tsx
#: src/components/PersonalTasksPage.tsx
msgid "In progress"
msgstr "进行中"

#: src/lib/taskStatus.tsx
msgid "In Progress"
msgstr "进行中"

#: src/components/PersonalTasksPage.tsx
msgid "In review"
msgstr "审核中"

#: src/lib/taskStatus.tsx
msgid "In Review"
msgstr "审核中"

#: src/components/ExecutionUsageChip.tsx
msgid "Input"
msgstr "输入"

#. placeholder {0}: formatTokens(i18n, execution.input_tokens)
#. placeholder {1}: formatTokens(i18n, execution.output_tokens)
#: src/components/ExecutionUsageChip.tsx
msgid "Input: {0} · Output: {1}"
msgstr "输入：{0} · 输出：{1}"

#: src/components/TaskPropertiesEditor.tsx
msgid "Issue"
msgstr "议题"

#: src/components/PersonalOverview.tsx
msgid "Join a Project"
msgstr "加入项目"

#: src/components/PersonalOverview.tsx
msgid "Less"
msgstr "少"

#: src/components/ExecutionUsageChip.tsx
msgid "Lifecycle complete"
msgstr "生命周期记录完整"

#: src/components/ExecutionUsageChip.tsx
msgid "Lifecycle partial"
msgstr "生命周期记录不完整"

#: src/components/ExecutionUsageChip.tsx
msgid "Loading executions…"
msgstr "正在加载执行记录…"

#: src/components/InsightsPanel.tsx
msgid "Loading Project pulse…"
msgstr "正在加载项目动态…"

#: src/components/ServerTasksPage.tsx
msgid "Loading Project tasks…"
msgstr "正在加载项目任务…"

#: src/components/TasksPanel.tsx
msgid "Loading repository capability and mappings from the selected computer..."
msgstr "正在从所选电脑加载仓库能力和映射…"

#: src/components/TasksPanel.tsx
msgid "Loading repository mappings..."
msgstr "正在加载仓库映射…"

#: src/components/PersonalOverview.tsx
msgid "Loading your overview…"
msgstr "正在加载你的概览…"

#: src/components/PersonalTasksPage.tsx
msgid "Loading your tasks…"
msgstr "正在加载你的任务…"

#: src/components/PersonalOverview.tsx
msgid "Member"
msgstr "成员"

#: src/components/InsightsPanel.tsx
msgid "Messages"
msgstr "消息"

#: src/components/PersonalOverview.tsx
msgid "Mon"
msgstr "周一"

#: src/components/PersonalOverview.tsx
msgid "More"
msgstr "多"

#: src/components/PersonalTasksPage.tsx
#: src/components/TasksPanel.tsx
msgid "My Tasks"
msgstr "我的任务"

#: src/components/PersonalOverview.tsx
#: src/components/PersonalTasksPage.tsx
msgid "Needs attention"
msgstr "需要关注"

#: src/components/ServerTasksPage.tsx
#: src/components/TasksPanel.tsx
msgid "New Task"
msgstr "新建任务"

#: src/components/ActivityPanel.tsx
msgid "New task activity is unavailable because earlier requests occupy the local display capacity."
msgstr "较早的请求已占满本地显示容量，无法显示新的任务活动。"

#: src/components/PersonalOverview.tsx
msgid "Next up"
msgstr "接下来"

#: src/components/ExecutionUsageChip.tsx
msgid "No executions to chart."
msgstr "暂无可展示的执行记录。"

#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "No matching tasks."
msgstr "没有匹配的任务。"

#: src/components/TasksPanel.tsx
msgid "No repository mappings found. Go to Computers, clone the repository on that computer, then bind its directory."
msgstr "未找到仓库映射。请前往“电脑”，在对应电脑上克隆仓库后绑定其目录。"

#: src/components/PersonalTasksPage.tsx
msgid "No tasks here."
msgstr "这里还没有任务。"

#: src/components/InsightsPanel.tsx
msgid "No visible contributors yet."
msgstr "暂无可见的贡献者。"

#: src/components/InsightsPanel.tsx
msgid "No visible task activity yet."
msgstr "暂无可见的任务活动。"

#: src/components/PersonalOverview.tsx
msgid "Not connected yet"
msgstr "尚未连接"

#: src/components/StopTurnButton.tsx
msgid "Nothing to stop"
msgstr "没有可停止的工作"

#: src/components/PersonalOverview.tsx
msgid "Offline"
msgstr "离线"

#: src/components/PersonalOverview.tsx
msgid "Online"
msgstr "在线"

#: src/components/TaskPropertiesEditor.tsx
msgid "Open"
msgstr "打开"

#: src/lib/taskStatus.tsx
msgctxt "Task status"
msgid "Open"
msgstr "待处理"

#. placeholder {0}: task.title
#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "Open {0}"
msgstr "打开{0}"

#. placeholder {0}: source.guild_name
#. placeholder {1}: source.channel_name
#: src/components/TasksTableView.tsx
msgid "Open {0} #{1}"
msgstr "打开 {0} 的 #{1}"

#: src/components/PersonalOverview.tsx
msgid "Open an invite link from a Project owner, or create your own Project."
msgstr "打开项目所有者提供的邀请链接，或创建自己的项目。"

#: src/components/TasksPanel.tsx
msgid "Open the task's channel to load available assignees. Other task fields can still be edited."
msgstr "请打开任务所在频道以加载可选负责人。仍可编辑其他任务字段。"

#: src/components/TasksBoardView.tsx
#: src/components/TasksTableView.tsx
msgid "Open thread"
msgstr "打开讨论串"

#: src/components/TasksPanel.tsx
msgid "Optional description"
msgstr "描述（可选）"

#: src/components/ExecutionUsageChip.tsx
msgid "Output"
msgstr "输出"

#: src/components/PersonalOverview.tsx
msgid "Overview"
msgstr "概览"

#: src/components/InsightsPanel.tsx
msgid "Partial coverage — telemetry was reported, but no complete token trend is available."
msgstr "记录不完整：已收到用量报告，但没有完整的 token 趋势。"

#: src/components/TasksTableView.tsx
msgid "Participants"
msgstr "参与者"

#: src/components/PersonalOverview.tsx
msgid "Paste a Borgee invite link from this Project."
msgstr "请粘贴此项目的 Borgee 邀请链接。"

#: src/components/PersonalOverview.tsx
msgid "Paste an invite link from a Project owner. You will review and accept the invitation before joining."
msgstr "粘贴项目所有者提供的邀请链接。加入前，你可以查看并接受邀请。"

#: src/components/InsightsPanel.tsx
msgid "People contributing to visible work"
msgstr "为可见工作作出贡献的人"

#: src/components/TasksPanel.tsx
msgid "Periodic check-in prompt"
msgstr "定期检查提示词"

#: src/components/TasksPanel.tsx
msgid "Periodic check-in prompt (optional)"
msgstr "定期检查提示词（可选）"

#: src/components/PersonalOverview.tsx
#: src/components/PersonalTasksPage.tsx
msgid "Personal"
msgstr "个人"

#: src/components/PersonalOverview.tsx
msgid "Personal overview"
msgstr "个人概览"

#: src/components/PersonalOverview.tsx
#: src/components/PersonalTasksPage.tsx
msgid "Personal task"
msgstr "个人任务"

#: src/components/InsightsPanel.tsx
msgid "Project activity rhythm"
msgstr "项目活动节奏"

#: src/components/PersonalOverview.tsx
msgid "Project invite link"
msgstr "项目邀请链接"

#: src/components/InsightsPanel.tsx
msgid "Project pulse"
msgstr "项目动态"

#: src/components/TaskPropertiesEditor.tsx
msgid "Properties"
msgstr "属性"

#: src/components/TaskPropertiesEditor.tsx
msgid "Pull Request"
msgstr "拉取请求"

#: src/components/ActivityPanel.tsx
msgid "Queued"
msgstr "排队中"

#: src/components/ActivityPanel.tsx
msgid "Read-only · This earlier request is no longer active."
msgstr "只读 · 此历史请求已失效。"

#: src/components/ActivityPanel.tsx
msgid "Read-only · This session is unavailable."
msgstr "只读 · 该会话暂不可用。"

#: src/components/InsightsPanel.tsx
msgid "Recently updated across visible channels"
msgstr "可见频道中最近更新的工作"

#. placeholder {0}: propertyLabel(definition, i18n)
#: src/components/TaskPropertiesEditor.tsx
msgid "Remove {0}"
msgstr "移除{0}"

#: src/components/InsightsPanel.tsx
msgid "Reported telemetry from visible conversations."
msgstr "来自可见会话的用量报告。"

#: src/components/ExecutionUsageChip.tsx
msgid "Reports"
msgstr "报告次数"

#: src/components/TasksPanel.tsx
msgid "Repository and selected computer are fixed after mapping."
msgstr "映射建立后，仓库和所选电脑将固定。"

#: src/components/TasksPanel.tsx
msgid "Repository execution is unavailable while the selected computer is offline."
msgstr "所选电脑离线时，仓库执行不可用。"

#: src/components/TasksPanel.tsx
msgid "Repository mapping can only be added before the task starts."
msgstr "只能在任务开始前添加仓库映射。"

#: src/components/TasksPanel.tsx
msgid "Repository mapping is missing. Clone the repository on the selected computer, bind that directory in Computers, then retry."
msgstr "缺少仓库映射。请在所选电脑上克隆仓库，在“电脑”中绑定其目录后重试。"

#: src/components/TasksPanel.tsx
msgid "Repository mappings are available only to the owner of the selected computer."
msgstr "只有所选电脑的所有者可以使用仓库映射。"

#: src/components/TasksPanel.tsx
msgid "Repository mappings are managed in Computers. Borgee never clones or pulls repositories."
msgstr "仓库映射在“电脑”中管理。Borgee 不会克隆或拉取仓库。"

#: src/components/TasksPanel.tsx
msgid "Repository-mapped task stays on its selected computer. You may choose another assignee on that computer or clear the assignee."
msgstr "使用仓库映射的任务固定在所选电脑上。你可以改选该电脑上的其他负责人，或清除负责人。"

#: src/components/PersonalOverview.tsx
msgid "Resume work in this task thread."
msgstr "在此任务讨论串中继续工作。"

#: src/components/ServerTasksPage.tsx
msgid "Retry"
msgstr "重试"

#: src/components/ActivityPanel.tsx
msgid "Running"
msgstr "运行中"

#: src/components/ActivityPanel.tsx
msgid "Running in background"
msgstr "正在后台运行"

#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
msgid "Save"
msgstr "保存"

#: src/components/TaskPropertiesEditor.tsx
msgid "Save failed"
msgstr "保存失败"

#: src/components/TasksPanel.tsx
msgid "Saving..."
msgstr "正在保存..."

#: src/components/TaskRowActions.tsx
msgid "Saving…"
msgstr "正在保存…"

#: src/components/ServerTasksPage.tsx
msgid "Search Project tasks"
msgstr "搜索项目任务"

#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "Search results"
msgstr "搜索结果"

#: src/components/PersonalTasksPage.tsx
msgid "Search tasks"
msgstr "搜索任务"

#: src/components/PersonalTasksPage.tsx
#: src/components/ServerTasksPage.tsx
msgid "Search tasks…"
msgstr "搜索任务…"

#: src/components/ServerTasksPage.tsx
msgid "Select a channel"
msgstr "选择频道"

#: src/components/TasksPanel.tsx
msgid "Select a repository"
msgstr "选择仓库"

#: src/components/TasksPanel.tsx
msgid "Select assignee"
msgstr "选择负责人"

#: src/components/TasksPanel.tsx
msgid "Sent to the assignee each time this task's heartbeat runs. It replaces the default “Heartbeat: status update requested” check-in message and does not change the task description or instructions."
msgstr "每次任务心跳运行时发送给负责人。它会替换默认的“心跳：请更新状态”检查消息，不会更改任务描述或指令。"

#: src/components/ExecutionUsageChip.tsx
msgid "Started"
msgstr "已开始"

#: src/components/ActivityPanel.tsx
msgid "Started {startedLabel} · {elapsedLabel}"
msgstr "开始于{startedLabel} · 已运行{elapsedLabel}"

#. placeholder {0}: run.parentActivityLabel
#: src/components/ActivityPanel.tsx
msgid "Started by {0}"
msgstr "由{0}启动"

#: src/components/ActivityPanel.tsx
msgid "Starting in background"
msgstr "正在后台启动"

#: src/components/ServerTasksPage.tsx
#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Status"
msgstr "状态"

#: src/components/ExecutionUsageChip.tsx
msgid "Status: {status}"
msgstr "状态：{status}"

#: src/components/ActivityPanel.tsx
#: src/components/StopTurnButton.tsx
msgid "Stop"
msgstr "停止"

#: src/components/ActivityPanel.tsx
msgid "Stop requested"
msgstr "已请求停止"

#: src/components/StopTurnButton.tsx
msgid "Stopped"
msgstr "已停止"

#: src/components/ActivityPanel.tsx
msgid "Stopping"
msgstr "正在停止"

#: src/components/ActivityPanel.tsx
#: src/components/StopTurnButton.tsx
msgid "Stopping…"
msgstr "正在停止…"

#: src/components/ActivityPanel.tsx
msgid "sub-agent"
msgstr "子 Agent"

#: src/components/ExecutionUsageChip.tsx
msgid "Succeeded"
msgstr "成功"

#: src/components/TasksPanel.tsx
msgid "Table view"
msgstr "表格视图"

#: src/components/TaskRowActions.tsx
#: src/components/TasksTableView.tsx
msgid "Task deleted"
msgstr "任务已删除"

#. placeholder {0}: task.id
#. placeholder {1}: i18n._(STATUS_COLUMNS.find(column => column.key === task.status)!.label)
#: src/components/TaskStatusPill.tsx
msgid "Task ID: {0} · Status: {1}"
msgstr "任务 ID：{0} · 状态：{1}"

#: src/components/TasksPanel.tsx
msgid "Task title"
msgstr "任务标题"

#: src/components/InsightsPanel.tsx
#: src/components/ServerTasksPage.tsx
msgid "Tasks"
msgstr "任务"

#: src/components/PersonalOverview.tsx
msgid "Tasks you are assigned to or participating in will appear here."
msgstr "分配给你或你参与的任务会显示在这里。"

#: src/components/TasksPanel.tsx
msgid "The selected computer is offline. Start Remote Helper, then retry."
msgstr "所选电脑已离线。请启动 Remote Helper 后重试。"

#: src/components/TasksPanel.tsx
msgid "This assignee is not linked to a repository-capable managed computer."
msgstr "此负责人未关联支持仓库执行的受管电脑。"

#: src/components/TasksPanel.tsx
msgid "This assignee must join the channel before receiving a new assignment."
msgstr "此负责人必须先加入频道才能接收新任务。"

#: src/components/ActivityPanel.tsx
msgid "This background run is no longer active"
msgstr "此后台运行已结束"

#: src/components/ActivityPanel.tsx
msgid "This provider does not support targeted background-run cancellation"
msgstr "此提供方不支持停止指定的后台运行"

#: src/components/ExecutionUsageChip.tsx
msgid "This task thread"
msgstr "此任务讨论串"

#: src/components/ExecutionUsageChip.tsx
msgid "This thread"
msgstr "此讨论串"

#: src/components/ServerTasksPage.tsx
#: src/components/TaskRowActions.tsx
#: src/components/TasksPanel.tsx
#: src/components/TasksTableView.tsx
msgid "Title"
msgstr "标题"

#. placeholder {0}: formatTokens(i18n, total)
#: src/components/ExecutionUsageChip.tsx
msgid "Token breakdown: {0} total"
msgstr "Token 用量明细：共 {0}"

#: src/components/InsightsPanel.tsx
msgid "Token consumption over time"
msgstr "Token 用量随时间的变化"

#: src/components/ExecutionUsageChip.tsx
#: src/components/InsightsPanel.tsx
msgid "Token usage"
msgstr "Token 用量"

#: src/components/ExecutionUsageChip.tsx
msgid "Token usage for this channel and threads you can access"
msgstr "此频道及你可访问的讨论串的 token 用量"

#: src/components/ExecutionUsageChip.tsx
msgid "Token usage for this task thread"
msgstr "此任务讨论串的 token 用量"

#: src/components/ExecutionUsageChip.tsx
msgid "Token usage for this thread"
msgstr "此讨论串的 token 用量"

#: src/components/ExecutionUsageChip.tsx
msgid "Top models"
msgstr "主要模型"

#: src/components/ExecutionUsageChip.tsx
msgid "Total"
msgstr "总计"

#. placeholder {0}: formatTokens(i18n, tokens)
#: src/components/ExecutionUsageChip.tsx
msgid "Total: {0} tokens"
msgstr "总计：{0} token"

#: src/components/ActivityPanel.tsx
msgid "Typing"
msgstr "正在输入"

#: src/components/TaskStatusPill.tsx
msgid "Unassigned"
msgstr "未分配"

#: src/components/InsightsPanel.tsx
msgid "Unavailable — no telemetry was reported from visible conversations."
msgstr "暂无数据：可见会话尚未报告用量。"

#: src/components/ActivityPanel.tsx
msgid "Unknown"
msgstr "未知"

#: src/components/TasksPanel.tsx
msgid "Update Remote Helper on the selected computer to enable repository mappings."
msgstr "请更新所选电脑上的 Remote Helper 以启用仓库映射。"

#: src/components/TasksTableView.tsx
msgid "Updated"
msgstr "更新时间"

#: src/components/ExecutionUsageChip.tsx
#: src/components/TasksTableView.tsx
msgid "Usage"
msgstr "用量"

#: src/components/PersonalOverview.tsx
msgid "View all"
msgstr "查看全部"

#: src/components/ExecutionUsageChip.tsx
msgid "View lifecycle details"
msgstr "查看生命周期详情"

#: src/components/ActivityPanel.tsx
msgid "Waiting"
msgstr "等待中"

#: src/components/ActivityPanel.tsx
msgid "Waiting for you"
msgstr "等待你的回复"

#: src/components/ActivityPanel.tsx
msgid "Waiting in background"
msgstr "在后台等待"

#: src/components/PersonalOverview.tsx
msgid "Wed"
msgstr "周三"

#: src/components/InsightsPanel.tsx
msgid "Work in motion"
msgstr "进行中的工作"

#: src/components/ActivityPanel.tsx
#: src/components/PersonalOverview.tsx
msgid "Working"
msgstr "工作中"

#: src/components/PersonalOverview.tsx
msgid "Working with"
msgstr "协作伙伴"

#. placeholder {0}: person.task_title
#: src/components/PersonalOverview.tsx
msgid "Working with you on “{0}”"
msgstr "与你共同处理“{0}”"

#: src/components/TaskPropertiesEditor.tsx
msgid "Workspace Mode"
msgstr "工作区模式"

#: src/components/PersonalTasksPage.tsx
msgid "You participate"
msgstr "你参与的任务"

#: src/components/PersonalTasksPage.tsx
msgid "Your agent"
msgstr "你的 Agent"

#: src/components/PersonalOverview.tsx
msgid "Your agents"
msgstr "你的 Agent"

#: src/components/PersonalOverview.tsx
msgid "Your computers"
msgstr "你的电脑"

#: src/components/PersonalOverview.tsx
msgid "Your message activity in task threads over the last year"
msgstr "过去一年你在任务讨论串中的消息活动"

#: src/components/PersonalOverview.tsx
msgid "Your work"
msgstr "你的工作"

#: src/components/PersonalOverview.tsx
msgid "Your work rhythm"
msgstr "你的工作节奏"
